import {
  GENERATED_HTML,
  LEAD_FORMS,
  LOADING,
} from "../actionType/webToLeadType";

const initialState = {
  leadForms: [],
  generatedHtml: null,
  loading: false,
};

const WebToLeadReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LEAD_FORMS:
      return { ...state, leadForms: payload };
    case GENERATED_HTML:
      return { ...state, generatedHtml: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default WebToLeadReducer;
